import { render, staticRenderFns } from "./IndustryContent.vue?vue&type=template&id=33642f47"
import script from "./IndustryContent.vue?vue&type=script&lang=js"
export * from "./IndustryContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports